export default __webpack_public_path__ + "images/6cd901770f001c71bd31ebbe727bbed1-rock.jpg";